module.exports = __webpack_public_path__ + "static/media/21ECLAC43.c3855f36.jpg";